module.exports = __webpack_public_path__ + "img/trend_up.263ce755.svg";